export enum TaxResidencyEnum {
  SCOTLAND = 1,
  UK = 2
}
